/* =============================================================
 * import
 * ========================================================== */
import barba from '@barba/core';
// import barbaPrefetch from '@barba/prefetch';
import * as barbaOpt from './options';
import * as routeCommon from '../route/common';
import top from '../route/top';
import schoolTop from '../route/schoolTop';
import club from '../route/club';
import news from '../route/news';
import {loadYouTubeAPI} from '../route/facility';
import {globalNavi} from '../modules/gnav';
import {isMobile, smoothScroll} from '../modules/common';
import * as transitionGlobal from './transition/global';
import * as transitionHome from './transition/toHome';
import * as transitionJunior from './transition/toJunior';
import * as transitionSenior from './transition/toSenior';
import {initParallax} from "../modules/parallax";
import * as scrollObserver from "../modules/scrollObserver";



/* =============================================================
 * variables
 * ========================================================== */

// アニメーション用の変数定義
const $body = document.body;
const domain = document.domain;
const $header = document.getElementById('header');



export default function barbaRun() {

  // barba.use(barbaPrefetch);

  barba.init({
    debug: false,
    // logLevel: 'debug',
    schema: {
      prefix: 'data-trans',
      wrapper: 'wrapper',
      container: 'container',
      namespace: 'namespace',
    },
    prevent: ({el, event}) => barbaOpt.customPreventCheck(el, event),
    // キャッシュを無効にするページ指定
    // cacheIgnore: [],
    views: [
      {
        namespace: 'home',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          top(data);
        },
      },
      {
        namespace: 'home_junior',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          schoolTop(data);
        },
      },
      {
        namespace: 'home_senior',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          schoolTop(data);
        },
      },
      {
        namespace: 'facility',
        beforeEnter() { // eslint-disable-line @typescript-eslint/no-unused-vars
          loadYouTubeAPI();
        },
        /*
        afterEnter() { // eslint-disable-line @typescript-eslint/no-unused-vars
          //initializeYouTubePlayer();
        },
        */
      },
      {
        namespace: 'club',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          club(data);
        },
      },
      {
        namespace: 'news',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          news();
        },
      },
    ],

    transitions: [
      // https://barba.js.org/docs/advanced/hooks/#Base-hooks
      {
        // 全ページ共通のトランジション
        name: 'global-transitions',
        sync: true, // 同時実行モード
        async leave(data) {
          const duration = 500;

          ttStart();
          barbaOpt.resetAnyFunc(data); // 各イベントトリガーのリセット
          transitionGlobal.leave(data, duration);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        async enter(data) {
          const duration = 10;

          globalNavi(data.next);
          transitionGlobal.enter(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        afterEnter() {
          scrollObserver.floating();
        },
        after(data) {
          const duration = 400;
          setTimeout(() => {
            ttEnd(data);
            transitionGlobal.after(data, duration);
          }, duration);
        },
      },
      {
        // 各ルールに応じた個別トランジションの設定
        name: 'to-home',
        sync: true, // 同時実行モード
        to: {
          // どのページへの遷移か
          namespace: [
            'home',
          ],
        },
        async leave(data) {
          const duration = 500;

          ttStart();
          barbaOpt.resetAnyFunc(data); // 各イベントトリガーのリセット
          transitionHome.leave(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        async enter(data) {
          const duration = 10;

          globalNavi(data.next);
          transitionHome.enter(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        afterEnter() {
          scrollObserver.floating();
        },
        after(data) {
          const duration = 300;
          setTimeout(() => {
            ttEnd(data);
            transitionHome.after(data);
          }, duration);
        },
      },
      {
        // 各ルールに応じた個別トランジションの設定
        name: 'to-junior',
        sync: true, // 同時実行モード
        /*
        from: {
          // どのページからの遷移か
          custom: ({ current }) => {
            return current.container.classList && !current.container.classList.contains('junior');
          },
        },
        */
        to: {
          // どのページへの遷移か
          namespace: [
            'home_junior',
          ],
        },
        async leave(data) {
          const duration = 800;

          ttStart();
          barbaOpt.resetAnyFunc(data); // 各イベントトリガーのリセット
          transitionJunior.leave(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        async enter(data) {
          const duration = 10;

          globalNavi(data.next);
          transitionJunior.enter(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        afterEnter() {
          scrollObserver.floating();
        },
        after(data) {
          const duration = 300;
          setTimeout(() => {
            ttEnd(data);
            transitionJunior.after(data);
          }, duration);
        },
      },
      {
        // 各ルールに応じた個別トランジションの設定
        name: 'to-senior',
        sync: true, // 同時実行モード
        /*
        from: {
          // どのページからの遷移か
          custom: ({ current }) => {
            return current.container.classList && !current.container.classList.contains('senior');
          },
        },
        */
        to: {
          // どのページへの遷移か
          namespace: [
            'home_senior',
          ],
        },
        async leave(data) {
          const duration = 800;

          ttStart();
          barbaOpt.resetAnyFunc(data); // 各イベントトリガーのリセット
          transitionSenior.leave(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        async enter(data) {
          const duration = 10;

          globalNavi(data.next);
          transitionSenior.enter(data);

          await new Promise((resolve) => {
            return setTimeout(resolve, duration);
          });
        },
        afterEnter() {
          scrollObserver.floating();
        },
        after(data) {
          const duration = 300;
          setTimeout(() => {
            ttEnd(data);
            transitionSenior.after(data);
          }, duration);
        },
      },
    ],

  });

  barba.hooks.beforeEnter(({next}) => {
    barbaOpt.replaceHeadTags(next);

    // barbaOpt.scrollAdjuster();
    // routeCommon.cursor();
    // routeCommon.cursorAnimation();
    if (domain === 'bunri-s.ed.jp') {
      const gaArg = {
        type: 'gtag',
        path: next.url.path,
        account: [
          'UA-63663110-39',
        ],
      };
      barbaOpt.gaSend(gaArg);
    }
    // barbaOpt.snsBtnReload(next.url.href);
    routeCommon.before(next);
  });

  barba.hooks.afterEnter((data) => {
    routeCommon.after(data.next);
    barbaOpt.samePageNotReload();

    const trigger = data.trigger;
    let hash = '';

    if (trigger === 'barba') {
      hash = window.location.hash;
    } else if (trigger !== '' && trigger !== 'back' && trigger !== 'forward') {
      const urlHash = trigger.data;
      const dataHash = trigger.dataset.scrollHash;
      if (dataHash !== undefined && dataHash !== null && dataHash !== '') {
        hash = dataHash;
      } else
      if(urlHash !== undefined && urlHash !== null && urlHash !== '') {
        hash = urlHash;
      }
    }

    smoothScroll(hash); // スムーススクロールを実行
  });

  barba.hooks.after(() => {
    initParallax();
  });

  /*
   * Transitions
   *  beforeOnce, once, afterOnce, before,
   *  beforeLeave, leave, afterLeave, afterLeave,
   *  enter, afterEnter, after
   * Views
   *  beforeLeave, afterLeave, beforeEnter, afterEnter
   * */

}

// トランジション開始時の設定
function ttStart() {
  $body.classList.remove('loaded'); // ロード完了のclassを解除
  $body.classList.add('loading'); // ローディング用のclassを追加
  $header.classList.remove('scrolled'); // スクロール開始クラスを解除（初期化）
  $header.style.pointerEvents = 'none'; // ヘッダー（ナビゲーション含む）を操作不可に設定
}

// トランジション終了時の設定
function ttEnd(data) {

  $body.classList.remove('loading');
  $body.classList.add('loaded');
  $header.style.pointerEvents = 'auto';
  // $header.style.opacity = 1;。

  // 共通パーツの初期化（遷移時にスクロールイベントが発生しクラスの付与等が発生するため）
  const namespace = data.next.namespace; // barbajsからdataを取得
  const hum = document.querySelector('.hum');
  const headerLogo = document.querySelector('.header_logo');
  hum.classList.remove('negative');
  headerLogo.classList.remove('negative');
  $header.classList.remove('negative'); // ヘッダーのネガティブ表示を解除

  // topページのみheaderにnegative class をデフォルトで付与
  if (namespace === 'home') {
    $header.classList.add('negative');
  }

  // video要素が存在する場合、自動再生を開始
  const videoElements = document.querySelectorAll('video');
  for (const videoElement of videoElements) {
    if (videoElement.hasAttribute('autoplay')) {
      videoElement.play();
    }
  }

  if (isMobile()) {
    data.next.container.classList.add('touch_device');  // touch device時に各種アニメーション等々を消すためのクラス（遷移時）
  }

}

